import React from 'react';
import DataFilter from "../components/Helpers/DataFilter"
import TimeSheetTable from '../components/TimeDataTable/TimeSheetTable.jsx';

export default function TimeSheetLanding() {
    return (
        <div>
            {/* Add the Date filter -- remove the locations */}

            {/* Bring in the data grid */}
            <TimeSheetTable dateFilter={null} />
        </div>
    );
};
